<template>
	<div>
		
		<v-row>
			<v-col class="d-flex">
				Benvenuto nel Click Day Manager, qui potrai gestire le tue pratiche<span v-if="!isAzienda">&nbsp;e visionare il materiale informativo</span>.
			</v-col>
			<v-col cols="3" class="d-flex">
				<!--<v-sheet-->
				<!--	rounded-->
				<!--	outlined-->
				<!--	class="tour-step-1 pa-3"-->
				<!--	style="width: 100%"-->
				<!--&gt;-->
				<!--	<div class="font-weight-bold primary&#45;&#45;text">Il tuo Referente del Servizio Clienti</div>-->
				<!--	<div>Nome: {{ user.cliente.account_manager.nome }}</div>-->
				<!--	<div>Telefono: {{ user.cliente.account_manager.cellulare }}</div>-->
				<!--	<div>Email: {{ user.cliente.account_manager.email }}</div>-->
				<!--	<div>WhatsApp: <a :href="`${ user.cliente.account_manager.link_whatsapp || '#' }`">apri la chat</a></div>-->
				<!--</v-sheet>-->
			</v-col>
		</v-row>
		
		<v-row class="justify-center">
			<v-col v-if="!isAzienda" cols="6">
				<v-sheet
					rounded
					outlined
					class="pa-10"
				>
					<div class="d-flex align-center justify-center mb-5">
						<img
							src="https://s3.eu-central-1.amazonaws.com/manager.clickday.images/materiale_informativo.png"
							alt="Materiale Informativo"
							height="80"
							class="mr-6"
						>
						<div class="text-h5 text-center font-weight-medium mt-3 primary--text">
							Materiale<br>Informativo
						</div>
					</div>
					<div class="mb-6 text-center">
						Qui trovi il tuo accordo di prenotazione e il materiale informativo e divulgativo che potrai utilizzare per spiegare ai tuoi clienti cos’è e come funziona il Click Day
					</div>
					<div class="text-center">
						<v-btn
							:to="tourIsRunning ? null : { name: 'materiale_informativo' }"
							color="secondary"
							class="tour-step-2"
						>
							Clicca per entrare
						</v-btn>
					</div>
				</v-sheet>
			</v-col>
			<v-col cols="6">
				<v-sheet
					rounded
					outlined
					class="pa-10"
				>
					<div class="d-flex align-center justify-center mb-5">
						<img
							src="https://s3.eu-central-1.amazonaws.com/manager.clickday.images/gestione_pratiche.png"
							alt="Materiale Informativo"
							height="80"
							class="mr-6"
						>
						<div class="text-h5 text-center font-weight-medium mt-3 primary--text">
							Gestione<br>Pratiche
						</div>
					</div>
					<div class="mb-6 text-center">
						In questa sezione trovi i contratti di servizio, l’elenco delle pratiche affidateci e i relativi dettagli, come i documenti da caricare, l’assegnazione del cliccatore ecc.
					</div>
					<div class="text-center">
						<v-btn
							v-show="tourIsRunning && stepTargetName != '.tour-step-8'"
							color="secondary"
							class="tour-step-3"
						>
							Clicca per entrare
						</v-btn>
						<v-btn
							v-show="(tourIsRunning && stepTargetName == '.tour-step-8') || !tourIsRunning"
							:to="{ name: 'pratiche' }"
							color="secondary"
							class="tour-step-8"
						>
							Clicca per entrare
						</v-btn>
					</div>
				</v-sheet>
			</v-col>
		</v-row>
		
	</div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import { eventBus } from "@/event-bus";
export default {
	components: {},
	
	data() {
		return {
		
		}
	},
	
	computed: {
		...mapGetters({
			user: 'auth/user',
			isCliente: 'auth/isCliente',
			isAzienda: 'auth/isAzienda',
			tourIsRunning: 'tour/isRunning',
			startTourManually: 'tour/startManually'
		}),
		stepTargetName() {
			if (this.tourIsRunning) return this.$tours['guida'].step.target;
			else return null
		},
	},
	
	mounted() {
		if ((this.isCliente && !this.user?.cliente.guida_conclusa && !this.tourIsRunning) || this.startTourManually) {
			eventBus.$emit('start-tour');
			this.setStartTourManually(false);
		}
	},
	
	methods: {
		...mapMutations({
			setStartTourManually: 'tour/SET_START_MANUALLY'
		}),
	},
};
</script>